import React, { Component, PropTypes } from 'react';
import { get } from 'lodash';
import ReactSparkSelectInput from '../../../widgets/ReactSparkSelectInput';
import { Trivago } from '../../../../constants/ManageApps';
import Status from './StatusComponent';
import { isActive, getThirdPartyConfigDataToShow } from './utils';
import If from '../../../helpers/if';
import StatusMessage from './StatusMessageComponent';
import InputTextField from 'components/common/InputTextField';

class TrivagoSection extends Component {
    render() {
        const status = get(this.props.configurationObject, 'status');
        const chainStatus = get(this.props.chainConfigurationObject, 'status');
        const configurationObjectToShow = getThirdPartyConfigDataToShow(
            this.props.level,
            this.props.configurationObject,
            this.props.chainConfigurationObject
        );

        return (
            <section className="content-section">
                <Status
                    objectName="trivago"
                    isDisabled={this.props.isDisabled}
                    value={status}
                    parentValue={chainStatus}
                    level={this.props.level}
                    setValue={(key, value) => {
                        this.props.setValue(key, value);
                    }}
                />
                <StatusMessage appName={Trivago.appName} value={status} parentValue={chainStatus} />
                <If condition={isActive(this.props.level, status, chainStatus)}>
                    <div className="section-content col-md-12">
                        <p className="spark-message__content">
                            Complete the setup process with Trivago to receive an Advertiser ID. Enter it below to
                            activate Trivago referal tracking. The ID must be active for the channel indicated below.
                        </p>
                        <div className="send-trivago-tracking-info-options">
                            <ReactSparkSelectInput
                                label="Channel"
                                isDisabled={this.props.isDisabled || configurationObjectToShow.isInheritedData}
                                defaultValue={configurationObjectToShow.data.channel || 'lpadv'}
                                values={Trivago.channelsList.map(v => {
                                    return { key: v.key, label: v.label };
                                })}
                                onChange={event => {
                                    this.props.setValue('trivago.channel', event.target.value);
                                }}
                            />
                            <InputTextField
                                name="advertiser-Id"
                                sparkInputProps={{
                                    label: 'Trivago Advertiser ID*',
                                    errorMessage: configurationObjectToShow.data.advertiserIdIsInvalid
                                        ? 'Field is required'
                                        : ''
                                }}
                                disabled={this.props.isDisabled || configurationObjectToShow.isInheritedData}
                                value={configurationObjectToShow.data.advertiserId}
                                onChange={value => {
                                    this.props.setValue('trivago.advertiserId', value);
                                }}
                                maxLength={Trivago.advertiserIdMaxLength}
                            />
                        </div>
                    </div>
                </If>
            </section>
        );
    }
}

TrivagoSection.propTypes = {
    configurationObject: PropTypes.obj,
    chainConfigurationObject: PropTypes.obj,
    level: PropTypes.string,
    setValue: PropTypes.func.isRequired
};

export default TrivagoSection;



// WEBPACK FOOTER //
// ./src/components/pages/manage/apps/TrivagoSection.js